/* ============================================
   Artemis Theme — Product Form
   ============================================ */

(function () {
  'use strict';

  var productData = window.productData;
  if (!productData) return;

  var form = document.getElementById('product-form');
  var variantIdInput = document.getElementById('product-variant-id');
  var addToCartBtn = document.getElementById('add-to-cart');
  var priceContainer = document.getElementById('product-price');
  var optionSelects = document.querySelectorAll('[data-option-index]');
  var thumbnails = document.querySelectorAll('.product-page__thumbnail');
  var featuredImage = document.getElementById('product-featured-image');
  // Apparel PDPs expose only a Color selector and tag each thumbnail with its
  // color, letting the gallery and the Color selector stay in lock-step.
  var apparelColorSelect = document.querySelector('[data-apparel-color]');

  /* --- Apparel: color <-> thumbnail sync --- */
  function showThumbnail(thumb) {
    if (!thumb || !featuredImage) return;
    thumbnails.forEach(function (t) { t.classList.remove('product-page__thumbnail--active'); });
    thumb.classList.add('product-page__thumbnail--active');
    featuredImage.src = thumb.getAttribute('data-image-url');
    featuredImage.srcset = thumb.getAttribute('data-image-srcset');
    featuredImage.alt = thumb.getAttribute('data-image-alt');
  }

  /* Exposed so blocks outside this file can drive the gallery — logo-upload.js
     snaps to the blank-product shot when art lands. Deliberately not a
     synthesized thumbnail click: a click can also select that image's variant,
     and swapping the view shouldn't change what the customer is buying. */
  window.ArtemisGallery = { show: showThumbnail };

  function thumbnailForColor(color) {
    if (!color) return null;
    for (var i = 0; i < thumbnails.length; i++) {
      if (thumbnails[i].getAttribute('data-variant-color') === color) return thumbnails[i];
    }
    return null;
  }

  /* --- Variant Selection --- */
  function getSelectedOptions() {
    var options = [];
    optionSelects.forEach(function (select) {
      options.push(select.value);
    });
    return options;
  }

  // Reflect an option value into its image-swatch buttons (Base Color / Figure
  // Selection), if that option is rendered as swatches. Keeps the visible
  // swatch + its label in step when selection is driven from elsewhere.
  function syncSwatchUI(optIndex, value) {
    var btns = document.querySelectorAll('[data-swatch-btn][data-swatch-option="' + optIndex + '"]');
    btns.forEach(function (b) {
      var on = b.getAttribute('data-swatch-value') === value;
      b.classList.toggle('swatch-btn--active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    if (btns.length) {
      var label = document.querySelector('[data-swatch-label="' + optIndex + '"]');
      if (label && value != null) label.textContent = value;
    }
  }

  // Select a variant by id: push its option values into every selector
  // (dropdowns AND swatch buttons), then run the shared change flow so the
  // hidden variant id, price, and image all follow. Used by thumbnail clicks on
  // non-apparel PDPs.
  function selectVariantById(variantId) {
    var variant = productData.variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return false;
    optionSelects.forEach(function (select) {
      var idx = parseInt(select.getAttribute('data-option-index'), 10);
      var val = variant.options[idx];
      if (val == null) return;
      if (select.value !== val) select.value = val;
      syncSwatchUI(idx, val);
    });
    updateVariant();
    return true;
  }

  function findVariant(options) {
    // Match on the provided option values only; apparel PDPs supply just Color
    // (size lives in the designer), so we accept the first variant whose first
    // N options match.
    return productData.variants.find(function (variant) {
      return options.every(function (opt, index) {
        return opt === variant.options[index];
      });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Header badge piece count excludes the decoration-fee line — that line carries
  // the 1¢ fee product thousands of times to encode a dollar amount, so its
  // quantity must never reach the badge. Mirrors cart-icon.liquid / cart.js.
  function cartPieceCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      var isFee = item.properties && item.properties._decoration_fee === 'true';
      return isFee ? sum : sum + item.quantity;
    }, 0);
  }

  // Reflect the current count onto the header cart icon. The badge span is only
  // rendered server-side when the cart is non-empty, so adding the first item to
  // an empty cart finds no badge to update — create it here when one is needed.
  function updateCartCount(cart) {
    var pieces = cartPieceCount(cart);
    var link = document.querySelector('.header__cart');
    var badge = document.querySelector('.cart-count-badge');

    if (pieces > 0 && !badge && link) {
      badge = document.createElement('span');
      badge.className = 'cart-count-badge';
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    }

    if (badge) {
      badge.textContent = pieces;
      badge.style.display = pieces > 0 ? '' : 'none';
    }

    // The count is conveyed to assistive tech via the link's aria-label (the
    // badge is aria-hidden), so keep the "(N)" in step.
    if (link) {
      var label = link.getAttribute('aria-label');
      if (label) link.setAttribute('aria-label', label.replace(/\(\d+\)\s*$/, '(' + pieces + ')'));
    }
  }

  function updateVariant() {
    var options = getSelectedOptions();
    var variant = findVariant(options);

    if (!variant) return;

    // Update hidden variant ID
    variantIdInput.value = variant.id;

    // Update URL
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    // Update price
    var priceHtml = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var savings = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      priceHtml += '<span class="product-page__price-current product-page__price-current--sale">' + formatMoney(variant.price) + '</span>';
      priceHtml += '<span class="product-page__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
      priceHtml += '<span class="badge badge--sale">-' + savings + '%</span>';
    } else {
      priceHtml += '<span class="product-page__price-current">' + formatMoney(variant.price) + '</span>';
    }
    if (priceContainer) priceContainer.innerHTML = priceHtml;

    // Update add to cart button (may be absent on apparel PDPs — CTA is an anchor)
    if (addToCartBtn) {
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold out';
      }
    }

    // Update featured image. On apparel PDPs sync via the color->thumbnail map
    // so the gallery's active thumbnail tracks the Color selector; otherwise
    // fall back to the variant's own featured image.
    var colorThumb = apparelColorSelect ? thumbnailForColor(apparelColorSelect.value) : null;
    if (colorThumb) {
      showThumbnail(colorThumb);
    } else if (variant.featured_image && featuredImage) {
      var fsrc = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src;
      if (fsrc.indexOf('//') === 0) fsrc = 'https:' + fsrc;
      var fbase = fsrc.split(/[?&]width=/)[0];
      var sep = fbase.indexOf('?') >= 0 ? '&' : '?';
      // srcset takes precedence over src — rebuild it, or the browser keeps
      // rendering the previous image even after src changes.
      featuredImage.srcset =
        fbase + sep + 'width=600 600w, ' +
        fbase + sep + 'width=800 800w, ' +
        fbase + sep + 'width=1000 1000w, ' +
        fbase + sep + 'width=1400 1400w';
      featuredImage.src = fbase + sep + 'width=1000';
      featuredImage.alt = variant.featured_image.alt || productData.title;
    }
  }

  optionSelects.forEach(function (select) {
    select.addEventListener('change', updateVariant);
  });

  /* --- Image swatches (trophy Base Color / Figure Selection) ---
     Swatch buttons drive the hidden <select> for their option, then trigger the
     same change handler so variant id / price / image stay in step. */
  var swatchButtons = document.querySelectorAll('[data-swatch-btn]');
  swatchButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optIndex = btn.getAttribute('data-swatch-option');
      var value = btn.getAttribute('data-swatch-value');
      var select = document.querySelector('select[data-option-index="' + optIndex + '"]');
      if (!select) return;
      select.value = value;

      var group = btn.closest('.swatch-grid');
      if (group) {
        group.querySelectorAll('[data-swatch-btn]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('swatch-btn--active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }

      var label = document.querySelector('[data-swatch-label="' + optIndex + '"]');
      if (label) label.textContent = value;

      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* --- Image Thumbnails --- */
  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!featuredImage) return;

      // On apparel PDPs, if this thumbnail maps to a color, reflect it back into
      // the Color selector — updateVariant() then swaps the image and active
      // state (and keeps the variant id/price in step).
      var thumbColor = thumb.getAttribute('data-variant-color');
      if (apparelColorSelect && thumbColor && apparelColorSelect.value !== thumbColor) {
        apparelColorSelect.value = thumbColor;
        apparelColorSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      // Non-apparel PDPs: if this thumbnail is a variant's image, select that
      // variant — selectVariantById drives the option selectors/swatches and
      // updateVariant() then swaps the image and active thumbnail state.
      var thumbVariantId = thumb.getAttribute('data-variant-id');
      if (thumbVariantId) {
        showThumbnail(thumb);
        if (selectVariantById(thumbVariantId)) return;
      }

      showThumbnail(thumb);
    });
  });

  /* --- Initial sync ---
     The server renders product.featured_image and marks the first thumbnail
     active, but the Color selector defaults to selected_or_first_available_variant
     — which isn't the first variant when the first color is sold out or a
     ?variant= param is present. Without this, the page loads showing one color's
     image while the dropdown reads another. Re-point the gallery at the
     initially-selected color so they start in lock-step. */
  if (apparelColorSelect) {
    var initialThumb = thumbnailForColor(apparelColorSelect.value);
    if (initialThumb) showThumbnail(initialThumb);
  } else if (variantIdInput && variantIdInput.value && productData.variants && productData.variants.length > 1) {
    // Non-apparel PDPs drift the same way: the server renders product.featured_image
    // and marks the first thumbnail active, but the option selectors default to
    // selected_or_first_available_variant — a different variant when the first
    // color is sold out or a ?variant= param is present. Re-point the gallery at
    // the selected variant: prefer its mapped thumbnail (swaps image AND active
    // state), else fall back to updateVariant()'s image swap.
    var initVariant = productData.variants.find(function (v) {
      return String(v.id) === String(variantIdInput.value);
    });
    if (initVariant) {
      var initThumb = null;
      for (var i = 0; i < thumbnails.length; i++) {
        if (thumbnails[i].getAttribute('data-variant-id') === String(initVariant.id)) {
          initThumb = thumbnails[i];
          break;
        }
      }
      if (initThumb) {
        showThumbnail(initThumb);
      } else if (initVariant.featured_image) {
        updateVariant();
      }
    }
  }

  /* --- Date fields: minimum business-day lead time ---
     A date input tagged with data-min-business-days can't be satisfied by a
     static Liquid `min` (the page is cached, so "today" would go stale). Compute
     the earliest allowed date in the browser, skipping weekends, and set the
     `min` attribute — native constraint validation then blocks earlier dates on
     submit (the same mechanism `required` relies on). */
  function addBusinessDays(start, n) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function toISODate(d) {
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + day;
  }

  // Parse a YYYY-MM-DD value as a LOCAL date (new Date('YYYY-MM-DD') is UTC, so
  // getDay() can be off by a day near midnight). Returns true for Sat/Sun.
  function isWeekend(iso) {
    if (!iso) return false;
    var p = iso.split('-');
    if (p.length !== 3) return false;
    var day = new Date(+p[0], +p[1] - 1, +p[2]).getDay();
    return day === 0 || day === 6;
  }

  document.querySelectorAll('input[type="date"][data-min-business-days]').forEach(function (input) {
    var days = parseInt(input.getAttribute('data-min-business-days'), 10);
    if (!days || days < 1) return;
    var minDate = addBusinessDays(new Date(), days);
    input.min = toISODate(minDate);

    // Native min/weekend constraints give a terse (or no) browser message.
    // Native date inputs can't disable weekends in the calendar popup, so we
    // validate the chosen value: block weekends and too-early dates with a
    // clear message, clearing it as soon as the value is valid again.
    function validate() {
      var msg = '';
      if (input.validity.rangeUnderflow) {
        msg = 'Please choose a date at least ' + days + ' business days from today.';
      } else if (isWeekend(input.value)) {
        msg = 'Please choose a weekday — we don’t produce or ship on weekends.';
      }
      input.setCustomValidity(msg);
    }
    input.addEventListener('input', validate);
    input.addEventListener('change', validate);
  });

  /* --- Clear personalization lines ---
     Wipes the text personalization inputs (line-item property text fields),
     leaving the ship date / checkboxes intact. The button is hidden until JS
     runs (progressive enhancement) and only shows once a line has text. The
     same clear runs automatically after a successful add-to-cart below. */
  var clearLinesBtn = document.querySelector('[data-clear-lines]');

  function personalizationLines() {
    if (!form) return [];
    return Array.prototype.slice.call(
      form.querySelectorAll('input[type="text"][name^="properties["]')
    );
  }

  function syncClearVisibility() {
    if (!clearLinesBtn) return;
    var anyFilled = personalizationLines().some(function (el) {
      return el.value.trim() !== '';
    });
    clearLinesBtn.hidden = !anyFilled;
  }

  function clearPersonalizationLines() {
    personalizationLines().forEach(function (el) {
      el.value = '';
      // Let dependent tools (proof preview, bulk template grid) react.
      el.dispatchEvent(new Event('input', { bubbles: true }));
    });
    syncClearVisibility();
  }

  if (clearLinesBtn) {
    clearLinesBtn.addEventListener('click', clearPersonalizationLines);
    personalizationLines().forEach(function (el) {
      el.addEventListener('input', syncClearVisibility);
    });
    syncClearVisibility();
  }

  /* --- Add-on lines ---
     Blocks that bring their own cart lines (product-addons.js) publish them as
     window.ArtemisExtraLines. When any are selected the whole add goes out as a
     single JSON items[] request instead of the plain form post: one /cart/add.js
     call is all-or-nothing, so an add-on can never land in the cart without the
     item it belongs to — or the other way round. */
  function formDataToItem(formData) {
    // Numeric id: the JSON endpoint is stricter about types than the form post
    // it replaces, and FormData hands back everything as a string.
    var item = {
      id: Number(formData.get('id')),
      quantity: parseInt(formData.get('quantity'), 10) || 1,
      properties: {}
    };
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value) !== '') item.properties[match[1]] = String(value);
    });
    return item;
  }

  function extraLines() {
    if (typeof window.ArtemisExtraLines !== 'function') return [];
    try {
      var lines = window.ArtemisExtraLines() || [];
      // Drop anything without a usable variant rather than letting it fail the
      // whole request — /cart/add.js is all-or-nothing across items[].
      return lines.filter(function (line) {
        return line && Number(line.id) > 0;
      }).map(function (line) {
        return {
          id: Number(line.id),
          quantity: parseInt(line.quantity, 10) || 1,
          properties: line.properties || {}
        };
      });
    } catch (err) {
      return [];
    }
  }

  var cartErrorEl = document.querySelector('[data-atc-error]');

  function setCartError(message) {
    if (!cartErrorEl) return;
    cartErrorEl.textContent = message || '';
    cartErrorEl.hidden = !message;
  }

  /* Preflight the variant id. `updateVariant()` bails without touching the
     hidden input when no variant matches the selected options — which happens
     when the option values on the page outrun the variant data (Shopify
     serializes only the first 250 variants, and this product has more). The
     stale or empty id then reaches /cart/add.js, which answers 422 "cannot find
     variant". Catch it here, where we can name the real problem. */
  function variantIdProblem(id) {
    if (!(id > 0)) return 'Please choose your options before adding to cart.';
    if (!productData.variants || !productData.variants.length) return '';
    var known = productData.variants.some(function (v) {
      return String(v.id) === String(id);
    });
    if (known) return '';
    console.warn('[artemis] variant id not in productData:', id,
      '— variants loaded:', productData.variants.length,
      '· hydration:', !!(window.ArtemisVariants && window.ArtemisVariants.enabled()));
    return 'That combination isn’t available to order online. Please pick a different option, or call 440.255.2193 and we’ll set it up for you.';
  }

  function addToCartRequest(formData) {
    var extras = extraLines();
    if (!extras.length) return { method: 'POST', body: formData };
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [formDataToItem(formData)].concat(extras) })
    };
  }

  /* --- AJAX Add to Cart ---
     Apparel PDPs use "Add to Designer" instead of submit; skip this handler. */
  if (form && addToCartBtn && !window.IS_APPAREL_PDP) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var formData = new FormData(form);
      var originalText = addToCartBtn.textContent;

      setCartError('');
      var problem = variantIdProblem(Number(formData.get('id')));
      if (problem) {
        setCartError(problem);
        return;
      }

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      fetch('/cart/add.js', addToCartRequest(formData))
        .then(function (response) {
          if (response.ok) return response.json();
          /* Shopify explains every rejection in the body — "You can only add 5
             of that item to your cart", a sold-out variant, an oversized line
             item property. Swallowing it left the customer (and us) staring at
             a bare "try again" with no idea which line failed. */
          return response.json().catch(function () { return null; }).then(function (body) {
            var reason = (body && (body.description || body.message)) || 'Add to cart failed';
            /* "Cannot find variant" on a variant the page rendered happily
               almost always means the product isn't purchasable rather than
               missing: draft status, or not published to the Online Store
               channel. Both render in preview and both fail here, so leave the
               merchant a pointer — the shopper just sees Shopify's wording. */
            if (/cannot find variant/i.test(reason)) {
              console.warn('[artemis] ' + reason + ' — check that every product in this add ' +
                'is Active and published to the Online Store sales channel (draft products ' +
                'render in preview but cannot be added to a cart).');
            }
            throw new Error(reason);
          });
        })
        .then(function () {
          addToCartBtn.textContent = 'Added!';

          // Fresh start for the next item: wipe the personalization lines.
          clearPersonalizationLines();

          // Update cart count in header
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { updateCartCount(cart); });

          setTimeout(function () {
            addToCartBtn.textContent = originalText;
            addToCartBtn.disabled = false;
          }, 2000);
        })
        .catch(function (err) {
          addToCartBtn.textContent = 'Error — try again';
          setCartError(err && err.message);
          setTimeout(function () {
            addToCartBtn.textContent = originalText;
            addToCartBtn.disabled = false;
          }, 2000);
        });
    });
  }

  /* --- >250-variant hydration ---
     Shopify serializes only the first 250 variants into productData (and the
     apparel snapshot). On products with more, colors past the cap aren't in the
     data, so findVariant() returns nothing and updateVariant() bails before the
     image/price/stock swap — the <select> changes but nothing else does. Pull
     the complete set from the Storefront API (variant-hydrate.js), swap it into
     the arrays the page already reads, then re-fire change so image / price /
     variant id (here) and the per-size stock grid (apparel-pdp.js) recompute.
     No-op when ≤250 variants or no Storefront token is configured. */
  if (productData.variants && productData.variants.length >= 250 &&
      window.ArtemisVariants && window.ArtemisVariants.enabled()) {
    window.ArtemisVariants.fetchAll(productData.handle).then(function (list) {
      if (!list || !list.length) return;
      productData.variants = window.ArtemisVariants.toProductData(list);
      if (window.PDP_PRODUCT_SNAPSHOT) {
        window.PDP_PRODUCT_SNAPSHOT.variants = window.ArtemisVariants.toSnapshot(list);
      }
      var sel = apparelColorSelect ||
        (optionSelects.length ? optionSelects[optionSelects.length - 1] : null);
      if (sel) sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
})();
